module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/icon/desktop/svg/inner_down_right_fill_44-7c980b.svg";